export const NTER_PRINT_HEADER = `
<div style="display:flex;justify-content:space-between;align-items:center;background:#f7f9fa;padding:12px 30px;border-bottom:1px solid #ddd;width:100%;font-family:Arial,Helvetica,sans-serif;">
  <div style="display:flex;align-items:center;gap:10px;">
    <img src="{{landlordLogo}}" alt="Logo" style="width:40px;height:40px;">
    <div style="display:flex;flex-direction:column;">
      <h1 style="margin:0;font-size:18px;font-weight:bold;color:#333;">{{docTitle}}</h1>
      <span style="font-size:11px;color:#666;">{{docSubtitle}}</span>
    </div>
  </div>
  <div style="font-size:11px;color:#666;align-self:flex-start"><span style="color:darkgrey">DOC ID: </span> {{docId}}</div>
</div>
`;

export const NTER_PRINT_FOOTER = `
<div style="display:flex;justify-content:space-between;align-items:center;background:#f7f9fa;padding:12px 30px;border-top:1px solid #ddd;width:100%;font-family:Arial,Helvetica,sans-serif;">
  <div style="font-size:12px;color:#333;line-height:1.4;">
    <div><strong>{{landlordName}}</strong></div>
    <div>{{locationName}}</div>
    <div>{{offeringName}}</div>
  </div>
  <div style="text-align:center;">
    {{svgLogo}}
    <div style="font-size:10px;color:#333;padding-top:5px">Page <span class='pageNumber'></span> of <span class='totalPages'></span></div>
  </div>
  <div style="text-align:right;font-size:11px;color:#333;line-height:1.4;">
    <div>{{generatedBy}} {{generatedOn}}</div>
    <div>&copy; Nter {{generatedYear}} | All Rights Reserved</div>
    <div>
    <a href="https://nter.io/terms-and-conditions" target="_blank">Terms and Conditions</a> | <a href="https://nter.io/privacy-policy" target="_blank">Privacy Policy</a>
    </div>
  </div>
</div>
`
